/**
 * Захиалгын "худалдан авсан сувгийн төлөв" — энэ модуль нь цорын ганц эх сурвалж.
 *
 * Код (`PAY_LATER`, `BANK`, …) нь backend-ийн `chef-api/paymentChannel.js`-тэй ижил
 * байх ёстой: тэнд SQL дотор тооцоолж, энд нэр болгон харуулна. Шинэ суваг нэмэх бол
 * зөвхөн дараах 3 газрыг өөрчилнө: энэ файлын `PAYMENT_CHANNEL`, `PAYMENT_CHANNEL_LABELS`,
 * `PAYMENT_CHANNEL_FILTER_ORDER` (мөн backend-ийн CASE).
 */

/** Сувгийн кодууд — backend-аас ирдэг утгууд. */
export const PAYMENT_CHANNEL = {
  PAY_LATER: 'PAY_LATER',
  BANK: 'BANK',
  ADMIN_APPROVED: 'ADMIN_APPROVED',
  UNPAID: 'UNPAID',
} as const;

export type PaymentChannel = typeof PAYMENT_CHANNEL[keyof typeof PAYMENT_CHANNEL];

/** Дэлгэцэнд харагдах монгол нэр — текстийг зөвхөн эндээс өөрчилнө. */
export const PAYMENT_CHANNEL_LABELS: Record<PaymentChannel, string> = {
  [PAYMENT_CHANNEL.PAY_LATER]: 'Дараа төлөх',
  [PAYMENT_CHANNEL.BANK]: 'Банкаар төлсөн',
  [PAYMENT_CHANNEL.ADMIN_APPROVED]: 'Админ баталгаажуулсан',
  [PAYMENT_CHANNEL.UNPAID]: 'Төлөгдөөгүй',
};

/** Шүүлтүүрийн dropdown-д харагдах дараалал. */
export const PAYMENT_CHANNEL_FILTER_ORDER: PaymentChannel[] = [
  PAYMENT_CHANNEL.PAY_LATER,
  PAYMENT_CHANNEL.BANK,
  PAYMENT_CHANNEL.ADMIN_APPROVED,
  PAYMENT_CHANNEL.UNPAID,
];

/**
 * `order_payment.method` талбарт бичигддэг утгууд (backend-ийн paymentChannel.js-тэй ижил).
 * Сувгийн тооцоолол эдгээрээс хамаардаг тул мөрийн дотор шууд бичихгүй.
 */
export const PAYMENT_METHOD = {
  /** Админ гараар бүртгэсэн төлбөр */
  ADMIN: 'Admin',
  /** cron job банкны гүйлгээгээр бүртгэсэн төлбөр */
  BANK: 'Khan bank',
} as const;

export type PaymentChannelOption = {
  key: string;
  value: string;
  text: string;
};

function isPaymentChannel(value: unknown): value is PaymentChannel {
  return typeof value === 'string' && Object.prototype.hasOwnProperty.call(PAYMENT_CHANNEL_LABELS, value);
}

/** Кодыг дэлгэцийн нэр болгоно. Тодорхойгүй утгад хоосон мөр буцаана. */
export function parsePaymentChannel(channel?: string | null): string {
  return isPaymentChannel(channel) ? PAYMENT_CHANNEL_LABELS[channel] : '';
}

/** Semantic UI Dropdown-д өгөх сонголтууд. */
export function paymentChannelOptions(): PaymentChannelOption[] {
  return PAYMENT_CHANNEL_FILTER_ORDER.map((channel) => ({
    key: channel,
    value: channel,
    text: PAYMENT_CHANNEL_LABELS[channel],
  }));
}

/** Өнгө оноодог CSS класс (`order.scss`, `order.report.scss` дахь `.payment-channel`). */
export function paymentChannelClassName(channel?: string | null): string {
  return `payment-channel ${String(channel || '').toLowerCase()}`;
}
